<template>
  <div @click="$emit('openQuestionModel')">
    <v-dialog v-model="dialog" persistent max-width="900px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline"> Skill Testing Questions </span>
          <v-spacer></v-spacer>
          <v-icon @click="$emit('openQuestionModel')">close</v-icon>
        </v-card-title>
        <v-tabs grow="grow">
          <v-tab ripple>
            Create Skill Testing Questions
          </v-tab>
          <v-tab ripple>
            Show Skill Testing Questions
          </v-tab>
          <v-tab-item>
            <v-card flat>
              <v-list three-line subheader>
                <v-col>
                  <v-text-field
                    label="Tier"
                    disabled
                    v-model="data.tier_prize_id"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-select
                    :items="skillQuestionData"
                    name="id"
                    item-value="id"
                    label="Select Questions"
                    item-text="question"
                    v-model="data.skill_testing_question_id"
                  ></v-select>
                </v-col>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item tab-item>
            <v-card flat>
              <v-data-table
                :headers="headers"
                :items="linkedData"
                :items-per-page="10"
                class="elevation-1"
              ></v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="$emit('openQuestionModel')"
            >Close</v-btn
          >
          <v-btn color="darken-1" class="primary" text @click="createBoost()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/clients/prizingapi/skill_testing_questions'
import tierPriceQuestions from '@/clients/prizingapi/tier_price_questions'
import header from './questionTableColumns'

export default {
  props: ['title', 'btnTitle', 'item', 'deleteModal'],
  data: () => ({
    dialog: true,
    headers: header,
    skillQuestionData: [],
    data: {
      tier_prize_id: '',
      skill_testing_question_id: ''
    },
    linkedData: []
  }),
  mounted () {
    this.data.tier_prize_id = this.item.id
    this.getSkillQuestions()
    this.getLinkedData()
  },
  methods: {
    getSkillQuestions () {
      this.spinner(true)
      api
        .getSkillTestingQuestions()
        .then(res => {
          this.skillQuestionData = res.data.payload
          this.spinner(false)
        })
        .catch(error => {
          this.spinner(false)
          return error
        })
    },
    createBoost () {
      this.spinner(true)
      tierPriceQuestions
        .createTierPrizeQuestions(this.data)
        .then(res => {
          this.data = {}
          this.spinner(false)
          this.getSkillQuestions()
          this.$emit('getTierPrizes')
          return this.snackbar({ text: 'Skill Question created successfully' })
        })
        .catch(error => {
          console.log(error)
          this.spinner(false)
          return this.snackbar({ text: error.response.data.msg })
        })
    },
    getLinkedData () {
      this.spinner(true)
      tierPriceQuestions
        .getTierPrizeQuestions()
        .then(res => {
          this.linkedData = res.data.payload
          this.spinner(false)
        })
        .catch(error => {
          this.spinner(false)
          return error
        })
    }
  },
  computed: {
    ...mapGetters({
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo'
    })
  }
}
</script>

<style lang="scss" scoped></style>
